import * as React from 'react';
import { useContext } from 'react';

import type { Maybe } from '__generated__/graphql-types';

import type { PageConfig_ComponentConfigFragment as PageConfigComponent } from 'bundles/page-config-common/queries/page-config/__generated__/PageConfigComponentsQuery';
import type { PageConfigFetchMoreFunction } from 'bundles/page-config-common/types/pagination';

type ComponentsConfigContextType = {
  components: Array<PageConfigComponent | undefined | null> | undefined | null;
  refetch: () => void;
  fetchMore?: PageConfigFetchMoreFunction;
  pagination?: {
    cursor?: Maybe<string>;
    componentListMetadataHash?: string;
  };
  loading?: {
    isInitiallyLoading: boolean;
    isFetchMoreLoading: boolean;
  };
};

const ComponentsConfigContext = React.createContext<ComponentsConfigContextType | undefined>(undefined);

/**
 * @description This hook is used to access the components config context.
 */
export const useComponentsConfig = () => {
  const context = useContext(ComponentsConfigContext);

  return context?.components;
};

export const useComponentsConfigRefetch = () => {
  const context = useContext(ComponentsConfigContext);

  return context?.refetch;
};

export default ComponentsConfigContext;

export const useConfigPagination = () => {
  const context = useContext(ComponentsConfigContext);

  return context?.pagination;
};

export const useConfigFetchMore = () => {
  const context = useContext(ComponentsConfigContext);

  return context?.fetchMore;
};

export const useLoading = () => {
  const context = useContext(ComponentsConfigContext);

  return context?.loading;
};
